export const ROUTE_PATH = '/guest-efs';
